<template>
  <transition
    enter-active-class="ease-in-out duration-500"
    leave-active-class="ease-in-out duration-500"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-class="opacity-100"
    leave-to-class="opacity-0">
    <div v-show="visible" @click="handleClick" :class="toastClass"
         class="fixed top-20 inset-x-4 md:inset-x-10 z-50 p-4 mb-2 rounded-lg shadow-lg cursor-pointer pointer-events-auto">
      <div class="font-bold">{{ title }}</div>
      <div>{{ description }}</div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
  props: {
    id: Number,
    type: String,
    title: String,
    description: String,
    duration: Number,
  },
  emits: ['close'],
  setup(props, { emit }) {
    const visible = ref(true);

    const toastClass = computed(() => {
      switch (props.type) {
        case 'success': return 'bg-green-500 text-white';
        case 'error': return 'bg-red-500 text-white';
        case 'warning': return 'bg-yellow-500 text-black';
        default: return 'bg-gray-300 text-black';
      }
    });

    const handleClick = () => {
      visible.value = false;
      emit('close', props.id);
    };

    return { visible, toastClass, handleClick };
  },
});
</script>
